import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Bot } from "lucide-react";

import { PlaceholderPage } from "@/components/cinch/PlaceholderPage";
import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

function AiPage() {
  return (
    <PlaceholderPage
      title="AI Agents"
      description="Embedded OpenWebUI with per-agent permission control."
      icon={Bot}
      plannedCapabilities={[
        "Code Q&A agent — codebase questions, design rationale",
        "Code Inspect agent — read PRs, suggest improvements",
        "Internal KB agent — search internal docs + decisions",
        "Per-user agent grants via ai.agent.* permissions",
      ]}
    />
  );
}

export const aiModule: FeatureModule = {
  key: "ai",
  nav: { label: "AI Agents", icon: Bot, to: "/ai", requires: "ai.read", order: 70, group: "Tools" },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/ai",
      component: guarded("ai.read", AiPage),
    }),
  ] as unknown as AnyRoute[],
};
